// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".username { padding: 5px 0px 5px 15px; font-weight: 500; }", "",{"version":3,"sources":["webpack://./src/app/shared/navbar/navbar.component.ts"],"names":[],"mappings":"AAAA,YAAY,yBAAyB,EAAE,gBAAgB,EAAE","sourcesContent":[".username { padding: 5px 0px 5px 15px; font-weight: 500; }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
